import { render, staticRenderFns } from "./FollowUpSms.vue?vue&type=template&id=26c72490&"
import script from "./FollowUpSms.vue?vue&type=script&lang=js&"
export * from "./FollowUpSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports